// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  display: none;
  width: 100px;
  height: 100px;
  background-image: url('spinner.46609396fc2513a7.svg');
  position: fixed;
  top: 45%;
  left: 50%;
}
.spinner.visible {
  display: block;
  animation: rotation 0.7s infinite linear;
  z-index: 40;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/spinner/spinner.component.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,qDAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AACJ;AACI;EACI,cAAA;EAEA,wCAAA;EACA,WAAA;AACR;AAaA;EACI;IAGI,uBAAA;EAHN;EAME;IAGI,yBAAA;EAJN;AACF","sourcesContent":[".spinner {\n    display: none;\n    width: 100px;\n    height: 100px;\n    background-image: url('../../styles/img/spinner.svg');\n    position: fixed;\n    top: 45%;\n    left: 50%;\n\n    &.visible {\n        display: block;\n        -webkit-animation: rotation .7s infinite linear;\n        animation: rotation .7s infinite linear;\n        z-index: 40;\n    }\n}\n\n@-webkit-keyframes rotation {\n    from {\n        -webkit-transform: rotate(0deg);\n    }\n\n    to {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes rotation {\n    from {\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    to {\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
